import { storeInformationQueries } from "$/hooks/use-store-information"
import { STORE_TIER } from "@repo/common"
import { QueryClient } from "@tanstack/react-query"
import { redirect } from "@tanstack/react-router"

export const requireNonFreeTier = async (queryClient: QueryClient) => {
  const storeInfo = await queryClient.ensureQueryData(
    storeInformationQueries.detail(queryClient),
  )
  const currentStore = storeInfo.stores.find(
    (store) => store.id === storeInfo.storeId,
  )
  if (currentStore?.tier === STORE_TIER.FREE) {
    throw redirect({ to: "/", replace: true })
  }
}
